import { render } from "./ShopBar.vue?vue&type=template&id=4f1a59c1&scoped=true"
import script from "./ShopBar.vue?vue&type=script&lang=js"
export * from "./ShopBar.vue?vue&type=script&lang=js"

import "./ShopBar.vue?vue&type=style&index=0&id=4f1a59c1&scoped=true&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/magic-shop-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f1a59c1"]])

export default __exports__